import script from "./__index.vue?vue&type=script&setup=true&lang=ts"
export * from "./__index.vue?vue&type=script&setup=true&lang=ts"

import "./__index.vue?vue&type=style&index=0&id=665615c4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-665615c4"]])

export default __exports__